import { createReducer, on, ActionReducer, Action } from '@ngrx/store';

import { LocaleState, InitialLocaleState } from './state';
import { SetLocaleProps, setLocaleAction, setLockedLocaleAction, localeLoadedAction } from './actions';
import { InjectionToken } from '@angular/core';

const reduceLocaleLoaded = (state: LocaleState, props: SetLocaleProps): LocaleState => {
  return {
    ...state,
    currentBcpLocale: props.bcpLocale
  };
};

export const localeReducer = createReducer(InitialLocaleState, on(localeLoadedAction, reduceLocaleLoaded));

export const LOCALE_REDUCER = new InjectionToken<ActionReducer<LocaleState, Action>>('locale reducer');
